import { EditableDetailsItem } from '@client/components/EditableField';

const getPointOfContactItems = <Values, >({
	pointOfContactName,
	pointOfContactEmail,
	pointOfContactPhoneNumber,
}: {
	pointOfContactName: string | null;
	pointOfContactEmail: string | null;
	pointOfContactPhoneNumber: string | null;
}): EditableDetailsItem<Values>[] => [
	{
		key: 'pointOfContactName',
		label: 'Name',
		value: pointOfContactName,
		type: 'text',
		editable: true,
	},
	{
		key: 'pointOfContactEmail',
		label: 'Email',
		value: pointOfContactEmail,
		type: 'text',
		editable: true,
	},
	{
		key: 'pointOfContactPhoneNumber',
		label: 'Phone number',
		value: pointOfContactPhoneNumber,
		type: 'text',
		editable: true,
	},
];

export default getPointOfContactItems;
